import { RolePermissionObjects } from './rolePermissionObjects.constants';

export const riskAssessmentRouteConfig = [
    { routerLink: '/dashboard/risk-assessments/assessments', title: 'Risk Assessments' },
    { routerLink: '/dashboard/risk-assessments/planning', title: 'Planning', objectId: RolePermissionObjects.SamplingPlan }
];
